import React from "react";

const typeStyles = {
  error: {
    container: "bg-red-50 border-red-300 text-red-900",
    icon: "text-red-700",
    role: "alert",
  },
  success: {
    container: "bg-green-50 border-green-300 text-green-900",
    icon: "text-green-700",
    role: "status",
  },
  warning: {
    container: "bg-amber-50 border-amber-300 text-amber-900",
    icon: "text-amber-800",
    role: "alert",
  },
  info: {
    container: "bg-blue-50 border-blue-300 text-blue-900",
    icon: "text-blue-800",
    role: "status",
  },
};

const AlertBanner = ({
  type = "info",
  title,
  message,
  onClose,
  className = "",
}) => {
  const styles = typeStyles[type] || typeStyles.info;

  return (
    <div
      role={styles.role}
      aria-live={type === "error" || type === "warning" ? "assertive" : "polite"}
      className={`border rounded-md p-4 ${styles.container} ${className}`}
    >
      <div className="flex items-start gap-3">
        <div className="flex-1 min-w-0">
          {title && (
            <p className="font-semibold mb-1">{title}</p>
          )}
          <div className="text-sm">{message}</div>
        </div>
        {onClose && (
          <button
            type="button"
            onClick={onClose}
            className={`shrink-0 rounded p-1 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-blue-600 ${styles.icon}`}
            aria-label="Dismiss alert"
          >
            <svg
              className="w-5 h-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              aria-hidden="true"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        )}
      </div>
    </div>
  );
};

export default AlertBanner;
